/** Bust browser cache for same-path uploads when product timestamps change. */
export function withUploadedImageCacheBust(src, row) {
  if (!src || typeof src !== "string") return src;
  let out = src;
  if (typeof window !== "undefined" && out.startsWith("/uploaded-products/")) {
    const host = window.location.hostname;
    const isLocal = host === "localhost" || host === "127.0.0.1";
    const port = String(window.location.port || "");
    if (isLocal && port === "3000") {
      const apiPort = process.env.REACT_APP_UPLOAD_API_PORT || "4001";
      out = `http://127.0.0.1:${apiPort}${out}`;
    }
  }
  const v = row?.updatedAt || row?.uploadedAt || row?.generatedAt;
  if (!v || !out.includes("/uploaded-products/")) return out;
  const sep = out.includes("?") ? "&" : "?";
  return `${out}${sep}v=${encodeURIComponent(String(v))}`;
}
